/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespRefineMenuFilterCategory_searchBrowse$ref: FragmentReference;
export type SbRespRefineMenuFilterCategory_searchBrowse = {|
  +pageType: ?string,
  +totalResults: ?number,
  +appliedFilters: ?$ReadOnlyArray<?{|
    +name: ?string,
    +localizedFilterName: ?string,
    +canBeDismissed: ?boolean,
    +values: ?$ReadOnlyArray<?{|
      +urlLabel: ?string,
      +count: ?number,
      +link: ?string,
      +displayName: ?string,
    |}>,
  |}>,
  +$refType: SbRespRefineMenuFilterCategory_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuFilterCategory_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pageType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalResults",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "appliedFilters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "localizedFilterName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "canBeDismissed",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "values",
          "storageKey": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParamValue",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "urlLabel",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "count",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "link",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "displayName",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '7a15eecd1c157b300a30c23877e297df';
module.exports = node;
